import Icon from '../components/Icon.vue'

Icon.register({
  'chess-board': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 256V320H192V256H256zM256 0H192V64H256V0zM256 256H320V192H256V256zM384 0H320V64H384V0zM384 512H448V448H384V512zM512 448V384H448V448H512zM128 512H192V448H128V512zM128 0H64V64H128V0zM512 192V128H448V192H512zM512 320V256H448V320H512zM0 512H64V448H0V512zM0 64V128H64V64H0zM0 192V256H64V192H0zM0 320V384H64V320H0zM256 512H320V448H256V512zM192 384V448H256V384H192zM256 192V128H192V192H256zM64 384V448H128V384H64zM128 256H64V320H128V256zM384 384H448V320H384V384zM512 0H448V64H512V0zM384 256H448V192H384V256zM384 64V128H448V64H384zM320 384V448H384V384H320zM128 320V384H192V320H128zM256 320V384H320V320H256zM192 192H128V256H192V192zM128 128H64V192H128V128zM320 320H384V256H320V320zM192 128V64H128V128H192zM320 128V64H256V128H320zM320 192H384V128H320V192z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chess-board.js
// module id = VdUw
// module chunks = 144